import { RATING_COLORS } from '../../shared/RatingBadge';
import { RATING_LETTERS, rateToLetter, letterToRate } from '../../../utils/ratingScale';

function RatingLetterPicker({ value, onChange }) {
    const activeLetter = rateToLetter(value);

    return (
        <div className="equip-rating-picker">
            {RATING_LETTERS.map((letter) => {
                const c = RATING_COLORS[letter];
                const active = letter === activeLetter;
                return (
                    <button
                        key={letter}
                        type="button"
                        className={`equip-rating-letter${active ? ' active' : ''}`}
                        style={active ? { background: c.bg, borderColor: c.bg, color: ['B', 'C'].includes(letter) ? '#181c22' : '#ffffff' } : { borderColor: c.border, color: c.tintText }}
                        onClick={() => onChange(letterToRate(letter))}
                    >
                        {letter}
                    </button>
                );
            })}
        </div>
    );
}

export default RatingLetterPicker;
